module.exports = __webpack_public_path__ + "static/media/jets.63303c72.jpg";